import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DownloadDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard'
    ),
);

const VodDownloadPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/vod-download'
    ),
);

const CctvVodPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/cctv-vod'
    ),
);

const AiVodPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/ai-vod'
    ),
);

const DasVProFilesPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/dasvpro-files'
    ),
);

const DevicesDataDownloadPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/devices-data'
    ),
);

const AlertDataDownloadPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/alert-data'
    ),
);

const AttendanceDataDownloadPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/attendance-data'
    ),
);

const DetailTimePage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/detail-time'
    ),
);

const PlantAttendanceDataDownloadPage = lazy(
  () =>
    import(
      /* webpackChunkName: "download-dashboard" */ '../../pages/download-dashboard/plant-attendance-data'
    ),
);

const downloadDashboardRouter = (
  <Route path="data-download-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="download-dashboard"
            component={<DownloadDashboardComponent />}
          />
        </Suspense>
      }
    >
      <Route
        path="vod"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="vod-download"
              component={<VodDownloadPage />}
            />
          </Suspense>
        }
      />
      <Route
        path="cctv-vod"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="cctv-vod"
              component={<CctvVodPage />}
            />
          </Suspense>
        }
      />
      <Route
        path="ai-vod"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer key="ai-vod" component={<AiVodPage />} />
          </Suspense>
        }
      />
      <Route
        path="dasvpro-files"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="dasvpro-files"
              component={<DasVProFilesPage />}
            />
          </Suspense>
        }
      />
      <Route
        path="devices-data"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="devices-data-download"
              component={<DevicesDataDownloadPage />}
            />
          </Suspense>
        }
      />
      <Route
        path="alert-data"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="alert-data-download"
              component={<AlertDataDownloadPage />}
            />
          </Suspense>
        }
      />
      <Route
        path="detail-time-report"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="detail-time-report-download"
              component={<DetailTimePage />}
            />
          </Suspense>
        }
      />
      <Route
        path="attendance-report"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="attendance-report-download"
              component={<AttendanceDataDownloadPage />}
            />
          </Suspense>
        }
      />
      <Route
        path="plant-attendance-report"
        element={
          <Suspense fallback={<Loading />}>
            <ErrorBoundaryContainer
              key="plant-attendance-report-download"
              component={<PlantAttendanceDataDownloadPage />}
            />
          </Suspense>
        }
      />
      {accountRouter()}
    </Route>
  </Route>
);

export default downloadDashboardRouter;
